import React, { Component } from "react";
import firebase from "../Config/Firebase";

class SplitEqualComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loggedInUser: '',
      users: [],
      items: [],
      total: 0,
      perItemTotal: 0,
      sumTotal: 0,
      splitTotal: 0,
      totalUsers: props.splitByTotalUsers || 1,
      itemSelected: [],
      splitBillCompleted: props.splitBillCompleted,
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleChange(e) {

    this.setState({
      totalUsers: e.target.value,
      splitBillTotal: this.props.splitBillTotal / parseInt(e.target.value, 10)
    });
    e.preventDefault();
  }
  handleClick() {
    console.log("Next Button Clicked");
    if (this.state.totalUsers) {
      return this.updateSplitEqualStats(this.state.totalUsers);
    } else {
      console.log("Please select a valid number of users");
    }
  }
  updateSplitEqualStats(noOfUsers) {
    this.setState({
      splitBillCompleted: true
    });
    return firebase.database().ref(`/tables/${this.props.tableID}/`).update({
      splitByTotalUsers: noOfUsers,
      splitBillCompleted: true,
      splitBillTotal: (this.props.tableTotal / parseInt(noOfUsers, 10)).toFixed(2)
    });
  }
  computePrice(items) {
    let total = 0;
    let sumTotal = 0;
    let splitTotal = 0;
    let totalUsers;
    let tableTotal = 0;
    let itemKeys = [];
    let itemSelectedKeys = [];

    let itemsSelected = [];
    items.forEach((element, key) => {
      if ((element.userAssigned === this.props.loggedInUser) && (element.paid === false)) {
        total += element.total;
        itemsSelected.push(element);
        itemSelectedKeys.push(key);
      }
      itemKeys.push(key);
      sumTotal += element.total;
    });

    if (this.props.splitBillTotal === 0) {
      tableTotal = this.props.tableTotal;
    } else {
      tableTotal = this.props.splitBillTotal;
    }
    splitTotal = ((sumTotal / this.state.totalUsers) / 100).toFixed(2);
    return { splitTotal, totalUsers, tableTotal };
  }
  render() {
    let itemStats = this.computePrice(this.props.items);
    if ((this.props.owner !== this.props.loggedInUser) && this.props.splitBillCompleted) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h4>
                <span>Split equally among</span>
                <br />
                {this.props.splitByTotalUsers}
                <br />
                <span>guests</span>
              </h4>
            </div>
            <br />
            <div className="col-sm-12">
              <hr />
              <p>Your Bill :<br />
                <span className="equalSplitAmount">
                  <strong>AUD ${this.props.splitBillTotal} / Person</strong>
                </span>
              </p>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className="container">
        {
          (!this.state.splitBillCompleted && (this.props.owner === this.props.loggedInUser)) &&
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label> Split equally among</label><br />
                {
                  (this.props.loggedInUser === this.props.owner) ? (
                    <select className="form-control col-sm-12" value={this.state.totalUsers} id="formControlSelect" onChange={this.handleChange} >
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                      <option>6</option>
                      <option>7</option>
                      <option>8</option>
                      <option>9</option>
                      <option>10</option>
                    </select>
                  ) : (
                      <span>{itemStats.totalUsers}</span>
                    )
                }
                <span>guests</span>
              </div>
            </div>
            <div className="col-sm-12">
              <button className="btn btn-info col-sm-12" onClick={this.handleClick.bind(this)}>NEXT</button>
            </div>
          </div>
        }
        {
          this.state.splitBillCompleted &&
          <div className="row">
            <div className="col-sm-12">
              <h4>
                <label> Split equally among </label>
                <br />
                <span>{this.state.totalUsers} </span>
                <br />
                <span>guests</span>
              </h4>
            </div>
            <div className="col-sm-12">
              <hr />
              <p>Your Bill :<br />
                <span className="equalSplitAmount">
                  <strong>AUD ${itemStats.tableTotal} / Person</strong>
                </span>
              </p>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default SplitEqualComponent;


// WEBPACK FOOTER //
// ./src/Components/SplitEqualComponent.js